window.addEventListener('load', () => {
    const dataLinkUrlElements = document.querySelectorAll<HTMLElement>('[data-link-url]');
    dataLinkUrlElements.forEach((element) => {
        const url = element.getAttribute('data-link-url');
        if (url) {
            // now we convert the element into a link
            const link = document.createElement('a');
            link.href = url;
            link.innerHTML = element.innerHTML;
            link.className = element.className;
            // replace the element with the link
            element.parentNode?.replaceChild(link, element);
        }
    });
});
